var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 22.138 22.138",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.061 3.804c-.594 0-1.076.482-1.076 1.077 0 .124.024.241.063.352l-3.154 4.694-3.897-3.753a1.077 1.077 0 1 0-2.133-.216c0 .533.389.972.898 1.058l2.544 6.399-2.94-1.446c.003-.034.01-.067.01-.102a1.077 1.077 0 1 0-2.154 0c0 .32.143.604.365.802l-.571 3.533c-.269.052-.5.205-.657.418l-6.222-1.682A1.074 1.074 0 0 0 0 15.104c0 .594.482 1.077 1.077 1.077.236 0 .452-.078.629-.206l6.564 1.773c.179.347.537.585.953.585.595 0 1.077-.481 1.077-1.076 0-.244-.084-.466-.221-.646l.604-3.738 3.706 1.824a1.074 1.074 0 1 0 1.145-1.211l-2.141-5.384 3.208 3.088a.555.555 0 0 0 .848-.091l3.464-5.156c.049.007.099.015.148.015a1.077 1.077 0 1 0 0-2.154z",
    style: {},
    fill: "#ffffff",
    "data-original": "#030104",
    opacity: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyline);
export default __webpack_public_path__ + "static/media/polyline.621ec479760f5fab220c2f0b3cad4d56.svg";
export { ForwardRef as ReactComponent };